/* eslint-disable import/prefer-default-export */
import { OrderingPlatformType } from "__generated__/gql/graphql";
import { getEnumSchema } from "utils/schemas/utils";
import * as yup from "yup";

export const name = yup
  .string()
  .label("Customer Name")
  .trim()
  .min(2)
  .required();

export const orderingPlatformType = getEnumSchema<OrderingPlatformType>(
  OrderingPlatformType,
)
  .label("Type")
  .required();

export const website = yup.string().url().trim().nullable().label("Website");

export const description = yup.string().ensure().trim().label("Description");

export const directRetailerId = yup
  .string()
  .uuid()
  .nullable()
  .label("Direct Retailer")
  .when("orderingPlatformType", {
    is: OrderingPlatformType.DIRECT_RETAILER,
    then: (s) =>
      // eslint-disable-next-line no-template-curly-in-string
      s.required("${label} is required for “Direct Retailer” customers."),
    otherwise: (s) => s,
  });

export const isParent = yup.bool().label("Parent?");

export const parentId = yup
  .string()
  .uuid()
  .nullable()
  .label("Parent")
  .when("isParent", {
    is: true,
    // eslint-disable-next-line no-template-curly-in-string
    then: (s) => s.is([null], "${label} cannot be set for parent customers."),
  });
